const initialiseDataLayer = () => {
  window.dataLayer = window.dataLayer || [];
};

const formName = 'Create Your CEF Trade Account';

export const gaRegisterFormSteps = (section, progress) => {
  initialiseDataLayer();

  window.dataLayer.push({
    event: 'FormSteps',
    formName,
    section,
    progress,
  });
};

export const gaRegisterFormFieldChange = (fieldName, fieldValue) => {
  initialiseDataLayer();

  if (fieldValue !== '') {
    window.dataLayer.push({
      event: 'FormProgression',
      formName,
      formField: fieldName,
    });
  }
};

export const gaRegisterFormError = errors => {
  initialiseDataLayer();

  Object.entries(errors).forEach(([fieldName, error]) => {
    const errorObject = {
      event: 'Error',
      formField: fieldName,
      errorMessage: error.message,
    };

    if (error && typeof error === 'object' && !Array.isArray(error)) {
      // If the error is an object (nested), check for a message property
      if (error.message) {
        // Log the error for the current field
        window.dataLayer.push(errorObject);
      } else {
        // Recursively call the function for nested errors
        gaRegisterFormError(error);
      }
    } else if (error) {
      // Log the error for the current field
      window.dataLayer.push(errorObject);
    }
  });
};

// Basic structure built, waiting to confirm with Dan on what we want
export const gaFailedAccountActivation = () => {
  initialiseDataLayer();

  window.dataLayer.push({
    event: 'FailedAccountActivation',
  });
};
